import { render, staticRenderFns } from "./loginFail.vue?vue&type=template&id=74f9e1f0&scoped=true"
import script from "./loginFail.vue?vue&type=script&lang=js"
export * from "./loginFail.vue?vue&type=script&lang=js"
import style0 from "./loginFail.vue?vue&type=style&index=0&id=74f9e1f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9e1f0",
  null
  
)

export default component.exports